import { FC, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

const GuestGuard: FC<PropsWithChildren> = ({ children }) => {
  const token = localStorage.getItem("token");

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default GuestGuard;
